import ModalPageHeader from "../../../components/global-layout/modal-page-header";
import OpenExcelModalForm from "../open-exel-modal-form";

function OpenExcelModal({
  handleExcelModal,
  magicDataOption,
  setExcelDownloadData,
  handleDownloadReport,
  isExcelLoading,
  excelDownloadData
}: any) {
  return (
    <div className="w-full h-full">
      <div className="w-full h-full flex flex-col">
        <ModalPageHeader
          title={"Report Download"}
          handleClose={handleExcelModal}
        />
        <div className="w-full h-full flex-auto">
          <div className="w-full h-full px-[4.7rem] pt-[3.7rem]">
            <OpenExcelModalForm
              handleExcelModal={handleExcelModal}
              magicDataOption={magicDataOption}
              setExcelDownloadData={setExcelDownloadData}
              handleDownloadReport={handleDownloadReport}
              isExcelLoading={isExcelLoading}
              excelDownloadData={excelDownloadData}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default OpenExcelModal;
